import React from "react";
import { convertToRupiah } from "../../../../helper/Rupiah";

const SortOrderHeader = ({ displayName, sortField, payloadSort, setSortOrderParent }) => {
  const isActive = payloadSort?.sort_by === sortField;
  const currentOrder = isActive ? payloadSort?.sort_type : null;

  const handleClickSort = () => {
    let newOrder;
    if (!isActive) {
      newOrder = "asc";
    } else if (currentOrder === "asc") {
      newOrder = "desc";
    } else if (currentOrder === "desc") {
      newOrder = null;
    }

    setSortOrderParent?.(newOrder ? { sort_by: sortField, sort_type: newOrder } : null);
  };

  return (
    <div
      className="flex items-center gap-2 justify-content-between cursor-pointer select-none w-full"
      onClick={handleClickSort}
      title={`Klik untuk mengurutkan ${displayName}`}
    >
      <span className="font-semibold text-blue-600">{displayName}</span>
      {isActive && currentOrder && (
        <i className={`text-gray-500 text-xs pi ${currentOrder === "asc" ? "pi-arrow-up" : "pi-arrow-down"}`}></i>
      )}
    </div>
  );
};

const headerBorder = {
  borderRight: "1px solid #dcdcdc",
};

export const ReportColumn = (handleSortOrder, payloadSort) => {
  return [
    {
      headerName: "No",
      field: "no", // ✅ ada di response
      width: 80,
      minWidth: 80,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Worker ID",
      field: "workerId", // ✅ worker_id → workerId
      sortable: false,
      filter: false,
      width: 125,
      minWidth: 125,
      pinned: "left",
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker ID",
        sortField: "worker_id",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Worker Name",
      field: "workerName", // ✅ worker_name → workerName
      sortable: false,
      filter: false,
      width: 125,
      minWidth: 125,
      pinned: "left",
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Name",
        sortField: "worker_name",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Worker Type",
      field: "workerType", // ✅ worker_type → workerType
      sortable: false,
      filter: false,
      width: 140,
      minWidth: 140,
      pinned: "left",
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Type",
        sortField: "worker_type",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Gross",
      field: "initialAmount", // ✅ initial_amount → initialAmount
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Gross",
        sortField: "amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
      valueFormatter: (p) => `Rp${convertToRupiah(p.value)}`,
    },
    {
      headerName: "Point",
      field: "point", // ✅ ada di response
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Point",
        sortField: "point",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      headerStyle: headerBorder,
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-success": (params) => params.value > 0,
      },
      valueFormatter: (p) => `Rp${convertToRupiah(p.value)}`,
    },
    {
      headerName: "Bonus",
      field: "bonus", // ✅ ada di response
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bonus",
        sortField: "bonus",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      headerStyle: headerBorder,
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-success": (params) => params.value > 0,
      },
      valueFormatter: (p) => `Rp${convertToRupiah(p.value)}`,
    },
    {
      headerName: "Upah Complain Close",
      field: "complaintAdditional", // ✅ complain_closed → complaintAdditional
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Upah Complain Close",
        sortField: "upah_complain_close",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-success": (params) => params.value > 0,
      },
      valueFormatter: (p) => `Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Kasbon",
      field: "kasbonDeduction", // ✅ kasbon -> kasbonDeduction
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Kasbon",
        sortField: "deduction",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      headerStyle: headerBorder,
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Cicilan",
      field: "cicilanDeduction", // ✅ cicilan → cicilanDeduction
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerStyle: headerBorder,
      headerComponentParams: {
        displayName: "Cicilan",
        sortField: "cicilan",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "BPJS",
      field: "bpjsDeduction", // ✅ bpjs → bpjsDeduction
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerStyle: headerBorder,
      headerComponentParams: {
        displayName: "BPJS",
        sortField: "insurance",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Topup BPJS",
      field: "depositDeduction", // ✅ topup_deposit → depositDeduction
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Topup BPJS",
        sortField: "topup_deposit",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Upah di Complaint",
      field: "complaintDeduction", // ✅ complaint_on_hold → complaintDeduction
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Upah di Complaint",
        sortField: "upah_di_complaint",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      headerStyle: headerBorder,
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Admin Fee",
      field: "feeBank", // ✅ fee_admin_bank → feeBank
      sortable: false,
      filter: false,
      width: 100,
      minWidth: 100,
      resizable: false,
      headerComponent: SortOrderHeader,
      headerStyle: headerBorder,
      headerComponentParams: {
        displayName: "Admin Fee",
        sortField: "admin_fee",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      cellClassRules: {
        "text-danger": (params) => params.value > 0,
      },
      valueFormatter: (p) => `${p.value > 0 ? "-" : ''}Rp${convertToRupiah(p.value || 0)}`,
    },
    {
      headerName: "Net",
      field: "finalAmount", // ✅ final_amount → finalAmount
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Net",
        sortField: "final_amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
      valueFormatter: (p) => `Rp${convertToRupiah(p.value)}`,
    },
    {
      headerName: "Bank",
      field: "bankCode", // ✅ bank_code → bankCode
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank",
        sortField: "bank_code",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Bank Account Name",
      field: "bankAccountName", // ✅ bank_account_name → bankAccountName
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank Account Name",
        sortField: "bank_account_name",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Bank Account",
      field: "bankAccount", // ✅ bank_account → bankAccount
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bank Account",
        sortField: "bank_account",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
    {
      headerName: "Email",
      field: "email", // ✅ ada di response
      sortable: false,
      filter: false,
      width: 200,
      minWidth: 200,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Email",
        sortField: "email",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      headerStyle: headerBorder,
    },
  ];
};
